module.exports = __webpack_public_path__ + "img/availableColors@2x.8a56b5f.webp";